import React, { useEffect, useState } from "react";

const VisitasCard = ({data, icon}) => {
    const [total, setTotal] = useState(0);
    const [entries, setEntries] = useState([]);

    const icon_class = icon ?? "fas fa-stethoscope";

    useEffect(() => {
        let t = 0;
        const e = [];

        for (const key in data) {
            if (key === 'label') continue;

            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const element = data[key];
                
                e.push({ label: key, value: element });
                t += element;
            }
        }

        setTotal(t);
        setEntries(e);
    }, [data]);

    return <div style={{
        borderRadius: "8px",
        padding: "7px",
        margin: "3px",
        minHeight: "100px",
        background: "white",
        flex: 1,
    }}>
        <div style={{
            padding: "10px",
            lineHeight: 1,
            position: "relative",
        }}>
            <div className="row mb-2">
                <div className="flex" style={{minHeight: "100%", width: "64px"}}>
                    <i className={`${icon_class} m-auto text-primary`} style={{fontSize: '48px'}}></i>
                </div>
                <div className="col">
                    <div className="text-primary" style={{fontWeight: 700, fontSize: "24px"}}>
                        {total.toLocaleString('en-US')}
                    </div>
                    <div><span style={{fontWeight: 600, fontSize: "18px"}}>{data?.label}</span></div>
                </div>
            </div>

            {entries.map((entry) => <div className="row" key={entry.label}>
                <div className="text-right ml-3" style={{fontWeight: 700, fontSize: "16px", width: "auto"}}>
                    {entry.value.toLocaleString('en-US')}
                </div>
                <div className="col">{entry.label}</div>
            </div>)}
        </div>
    </div>
};

export default VisitasCard;